module.exports = __webpack_public_path__ + "img/mms-2.a444d5d3.jpg";